import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environmentCAS';

export interface BulkEmailResponse {
  message: string;
  sent_project_ids?: string[];
  failed_project_ids?: string[];
  not_found_project_ids?: string[];
}

export interface BulkResendDevisResponse {
  message: string;
  sent_project_ids?: string[];
  failed_project_ids?: string[];
  not_found_project_ids?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ProjectHistoryService {
  private readonly API_URL = environment.casApiUrl + '/cas/api/project-history';

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('access_token');
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }

  bulkStepOneSavingsEmail(projectIds: string[]): Observable<BulkEmailResponse> {
    return this.http.post<BulkEmailResponse>(
      `${this.API_URL}/bulk-step-one-savings-email`,
      { project_ids: projectIds },
      { headers: this.getAuthHeaders() }
    );
  }

  bulkSendInfoEmail(projectIds: string[]): Observable<BulkEmailResponse> {
    return this.http.post<BulkEmailResponse>(
      `${this.API_URL}/bulk-send-info-email`,
      { project_ids: projectIds },
      { headers: this.getAuthHeaders() }
    );
  }

  bulkSendPerduEmail(projectIds: string[]): Observable<BulkEmailResponse> {
    return this.http.post<BulkEmailResponse>(
      `${this.API_URL}/bulk-send-perdu-email`,
      { project_ids: projectIds },
      { headers: this.getAuthHeaders() }
    );
  }

  bulkResendDevisEmail(projectIds: string[]): Observable<BulkResendDevisResponse> {
    return this.http.post<BulkResendDevisResponse>(
      `${this.API_URL}/bulk-resend-devis-email`,
      { project_ids: projectIds },
      { headers: this.getAuthHeaders() }
    );
  }
}
